<template>
  <client-information
    v-if="entries"
    class="client-info"
    :entries="entries"
    @updateCustomerInfo="updateClientInfo"
  />
</template>

<script>
import ClientInformation from './ClientInformation';

const dateFormat = require('dateformat');

export default {
  name: 'ClientInformationContainer',
  components: {
    ClientInformation,
  },
  data() {
    return {};
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
    customer() {
      return this.$store.state.customers.item;
    },
    entries() {
      return {
        birthday: this.customer.birth_date,
        phone: this.customer.phone_number,
        based: this.customer.location,
        last_visit: this.customer.last_update,
      };
    },
  },
  mounted() {
    this.$store.dispatch('customers/fetchItem', {
      id: this.customerId,
      scope: this.$store.getters['account/scope'],
    });
  },
  methods: {
    format(date) {
      return dateFormat(date, 'mmm dS, yyyy');
    },
    updateClientInfo(payload) {
      this.$store.dispatch('customers/patchCustomerInfo', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
    .client-info {
        &::v-deep .card-body {
            padding: 71px 45px !important;
        }
    }
</style>
